import { Card, Group, rem } from "@mantine/core";
import Title from "../components/Title";
import { Text, Image } from "@mantine/core";
import Marquee from "react-fast-marquee";

type Props = {
  id: string;
};

const CUSTOMERS = [
  "培正專業書院",
  "東華三院戴東培護埋安老院",
  "東華三院智趣軒長者社區支援服務中心",
  "柴灣浸信會社會服務處",
  "柴灣循道愛華村服務中心",
  "華富村扶康會康時天地",
  "深水埗聖公會愛童行計劃中心",
  "李炳紀念學校",
  "東涌獸醫中心",
  "香港圍棋文化學會",
  "手卷駅",
  "La Famille ",
  "Nail Me",
  "青木堂",
  "漁小館",
  "Lemongrass Bakery",
];

export default function OurCustomer({ id }: Props) {
  return (
    <section id={id}>
      <Title
        title="我們的客戶"
        description="我們的客戶群來自各行各業包括各行業的私營公司、學校、立案法團及慈善機構。"
      />
      <Marquee gradient={false} speed={50}>
        {CUSTOMERS.map((customer) => (
          <Card padding="md" radius="lg" key={customer} mr={25}>
            <Text c="dimmed" weight={500}>
              {customer}
            </Text>
          </Card>
        ))}
      </Marquee>
    </section>
  );
}
